var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "broadcast-sended-details" }, [
    _c("div", { staticClass: "broadcast-sended-details-title" }, [
      _vm._v("Gönderim Durumları"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "broadcast-sended-details-table" },
      [_c("SupsisTable", { attrs: { columns: _vm.cols, rows: _vm.details } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }